<template>
  <div style="background-color: #f7f7f7">
    <div class="header">
      <div class="header-box">
        <div class="title">
          {{ title }}
        </div>
        <div class="phone">客服热线：010-88614688</div>
      </div>
    </div>
    <div class="province-content">
      <div class="left-box">
        <div class="nav-bar">
          当前位置： <a href="/">首页</a> > {{ linkName }}
        </div>
        <h3>
          行政许可与服务事项
          <p></p>
        </h3>
        <div class="content" v-for="(item, index) in businessSysRecords" :key="item.id">
          <p>{{ item.sysName }}</p>

          <dl>
            <dd v-for="(link, key) in item.operationLinks" :key="link.id" :class="{
              disabled:
                link.linkStatus == 0 || (link.linkStatus == 1 && !isLogin),
            }" @click="goPage(link)">
              {{ link.linkName }}
            </dd>
          </dl>
        </div>
      </div>
      <div class="right-box">
        <!---未登录---->
        <div class="login-box" v-if="!isLogin">
          <div class="top-menu">
            <ul>
              <li v-for="(item, index) in loginButtons" :key="index" :class="{ cur: curIndex == item.id }"
                @click="curIndex = item.id">
                {{ item.name }}
              </li>
            </ul>
          </div>

          <div style="padding: 20px 20px 0 20px">
            <UserPwd v-if="curIndex == 0" />

            <KeyLogin v-if="curIndex == 1" />

            <div class="key-login-extra-links">
              <a href="javascript:void(0)" @click.prevent="showForgotPasswordTip">忘记密码</a>
              <span class="key-login-extra-sep">|</span>
              <a :href="REGISTER_URL" target="_blank" rel="noopener noreferrer">立即注册</a>
            </div>
          </div>
        </div>
        <!---已经登录---->
        <div class="loged-box" v-else>
          欢迎您：<span style="color: #1e9fff; font-weight: 600; font-size: 18px">{{ userInfo.userType == 1 ?
            userInfo.realName : userInfo.unitName }}</span><br />访问测绘地理信息市场监管与服务平台！<br />
          <el-button type="warning" style="width: 100%" @click="logOut">退出登录</el-button>
        </div>
        <div class="city-zone">
          <h4>{{ linkName }} 服务专区</h4>
          <table cellpadding="0" cellspacing="0" class="tb01">
            <tr>
              <td class="title">本省微信群:</td>
              <td>
                <img style="width: 100px; height: 100px" :src="wechatQrcode || provinceInfo.wechatQrcode" />
              </td>
            </tr>
            <tr>
              <td class="title">全国在线QQ服务:</td>
              <td>
                <a href="https://wpa1.qq.com/QPNgqRWc?_type=wpa&amp;qidian=true" target="_blank"><img
                    src="/img/qqjt.png" /></a>
              </td>
            </tr>
            <tr>
              <td class="title">全国在线微信服务:</td>
              <td>
                <a href="https://wpa1.qq.com/VgEx7FPF?_type=wpa&amp;qidian=true" target="_blank"><img
                    src="/img/wechat-fuwu.png" /></a>
              </td>
            </tr>
            <tr>
              <td class="title">全国测绘行业服务热线:</td>
              <td>010-88614688</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <FriendLink :friendlyLinks="friendlyLinks" />
    <div class="footer">
      <p>
        主管部门：{{ zgbm }} 关于我们 | 联系我们<br />
        技术支持：北京四维安信软件有限公司客服热线：010-88614688京ICP备19009628号-1
      </p>
    </div>
  </div>
</template>
<script setup>
import FriendLink from "./components/friendLink.vue";
import UserPwd from "./login/UserPwd";
import KeyLogin from "./login/KeyLogin.vue";
import { getProvincesDetail, getTempToken } from "@/api/home";
import { getCurrentInstance, ref, computed, onMounted, watch } from "vue";
import { storeToRefs } from "pinia";
import { ElMessageBox } from "element-plus";
import useUserStore from "@/store/modules/user";
import { useRoute } from "vue-router";
const route = useRoute();
const provinceInfo = JSON.parse(sessionStorage.getItem("provinceInfo")) || {};

const { proxy } = getCurrentInstance();
let curIndex = ref(0);
const urlData = {
  "bj": 2,
  "tj": 21,
  "heb": 28,
  "sx": 241,
  "sh": 867,
  "nm": 383,
  "ln": 506,
  "jl": 635,
  "hl": 713,
  "zj": 1018,
  "ah": 1131,
  "fj": 1269,
  "jx": 1373,
  "sd": 1496,
  "hen": 1671,
  "hb": 1866,
  "hn": 1996,
  "gd": 2146,
  "gx": 2308,
  "hi": 2446,
  "sc": 2516,
  "gz": 2737,
  "yn": 2840,
  "xz": 2994,
  "sn": 3076,
  "gs": 3204,
  "qh": 3317,
  "nx": 3370,
  "xj": 3403,
  "xjscjsbt": 3685
}
const loginButtons = ref([
  {
    id: 0,
    name: "账户登录",
  },
  {
    id: 1,
    name: "KEY登录",
  },
]);
let provinceName = ref("");
let businessSysRecords = ref([]);
let operationLinks = ref([]);
let friendlyLinks = ref([]);
const userStore = useUserStore();
const { userInfo } = storeToRefs(userStore);
const isLogin = computed(() => {
  return userStore.token;
});
watch(isLogin, (newVal, oldVal) => {
  if (newVal && !oldVal) {
    // 登录状态从 false 变为 true，调用接口更新左边按钮信息
    getProvinceEntranceInfo();
  }
});
const linkName = computed(() => {
  const name = provinceName || provinceInfo.linkName;
  return name;
});
function goPage(data) {
  if (data.linkStatus == 0) {
    return;
  } else if (data.linkStatus == 1) {
    getTempToken({
      linkId: data.id
    }).then(res => {
      if (res.success) {
        if (res.data) {
          window.open(data.linkUrl + res.data)
        }
      } else {
        proxy.$message.error(res.message)
      }
    });
  } else {
    window.open(data.linkUrl + "?id=" + data.id);
  }
}
function logOut() {
  ElMessageBox.confirm(
    "确定要退出登录吗？",
    "退出登录",
    {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }
  ).then(() => {
    userStore.logOut().then(() => {
      // 退出登录后刷新当前页面
      location.reload();
    });
  }).catch(() => {
    // 取消退出登录，什么都不做
  });
}

const REGISTER_URL =
  "https://zz.ch.mnr.gov.cn/Main/WorkEntrance.aspx?r=639100313316756206";

function showForgotPasswordTip() {
  ElMessageBox.alert(
    "点击右下方QQ或者微信进行交谈，提供单位名称和营业执照原件扫描件，可协助解锁和重置密码。",
    "忘记密码",
    {
      confirmButtonText: "知道了",
      type: "info",
    },
  );
}
let zgbm = ref("");
let title = ref("");
let wechatQrcode = ref("");
function getProvinceEntranceInfo() {

  const url = window.location.pathname
  const linkCode = urlData[url.substring(url.lastIndexOf('/') + 1)]
  const uInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  let params = {};
  if (uInfo && uInfo.areaId) {
    params = {
      areaId: uInfo.provinceId,
    };
  } else {
    params = {
      areaId: linkCode,
    };
  }
  getProvincesDetail(params).then((res) => {
    if (res.success) {
      businessSysRecords.value = res.data.businessSysRecords;
      operationLinks.value = res.data.operationLinks;
      friendlyLinks.value = res.data.friendlyLinks;
      zgbm.value = res.data.zgbm;
      title.value = res.data.title;
      provinceName.value = res.data.provinceName;
      wechatQrcode.value = res.data.wechatQrcode;
    } else {
      proxy.$message.error(res.message);
    }
  });
}
onMounted(() => {
  console.log("mounted---------调用获取省份信息");
  getProvinceEntranceInfo();
});
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 115px;
  padding-top: 40px;
  background-color: #1660a5;
  text-align: center;
  color: #fff;
  margin-top: 10px;

  p {
    line-height: 180%;
  }
}

.header {
  width: 100%;
  height: 80px;
  font-size: 30px;
  color: #fff;
  background-color: #1660a5;

  .header-box {
    max-width: 1166px;
    width: 100%;
    margin: 0 auto;
    line-height: 80px;

    .phone {
      font-size: 1rem;
      color: #ffd200;
      float: right;
    }

    .title {
      font-size: 1.4rem;
      float: left;
    }
  }
}

.province-content {
  max-width: 1166px;
  width: 100%;
  margin: 0 auto;
  padding-top: 20px;
  overflow: hidden;

  .left-box {
    width: 66%;
    height: 38.75rem;
    border: 1px solid #eaeaea;
    background-color: #fff;
    float: left;

    h3 {
      position: relative;
      width: 45rem;
      height: 1.875rem;
      margin: 1.25rem 0 0 0.94rem;
      padding: 0 0 10px 14px;
      border-bottom: 1px solid #eee;
      color: #046bba;

      p {
        position: absolute;
        width: 13.125rem;
        height: 0;
        border-bottom: 2px solid #046bba;
        left: 0;
        bottom: 0;
      }
    }

    .nav-bar {
      padding: 17px 0 0 15px;
      border-bottom: 1px solid #f8f8f8;
      padding-bottom: 15px;
    }

    .content {
      display: flex;
      align-items: flex-start;
      padding: 19px 0 19px 0;
      border-bottom: 1px solid #eee;
      width: 98%;
      margin-left: 15px;
      gap: 10px;
      box-sizing: border-box;

      p {
        letter-spacing: 2px;
        flex: 0 0 calc(38% - 5px);
        max-width: calc(38% - 5px);
        min-width: 0;
        margin: 0;
        line-height: 1.6;
        white-space: normal;
        word-break: break-all;
      }

      dl {
        flex: 0 0 calc(62% - 5px);
        max-width: calc(62% - 5px);
        min-width: 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: 8px;
        margin: 0;
        padding-right: 14px;
        box-sizing: border-box;

        dd {
          height: 1.875rem;
          line-height: 1.875rem;
          border: 1px solid #046bba;
          border-radius: 15px;
          font-size: 0.78rem;
          padding: 0 6px;
          letter-spacing: 1px;
          flex: 0 0 22%;
          max-width: 22%;
          min-width: 68px;
          box-sizing: border-box;
          margin: 0;
          cursor: pointer;
          color: #046bba;
          white-space: normal;
          word-break: break-all;
          text-align: center;

          &:hover {
            background: #046bba;
            color: #fff;
          }
        }

        .disabled {
          background-color: #fbfbfb;
          border: 1px solid #ccc;
          color: #ccc;
          cursor: not-allowed;

          &:hover {
            background: #fbfbfb;
            color: #ccc;
          }
        }
      }
    }
  }

  .right-box {
    width: 32%;
    margin-left: 12px;
    float: right;

    .login-box {
      border: 1px solid #eaeaea;
      background-color: #fff;
      min-height: 301px;

      .top-menu {
        background-color: #fafafa;
        box-sizing: border-box;

        ul {
          width: 380px;
          display: flex;
          justify-content: space-around;

          li {
            width: 150px;
            height: 40px;
            line-height: 40px;
            cursor: pointer;
            font-size: 14px;
            letter-spacing: 1px;
            text-align: center;
            cursor: pointer;

            &.cur {
              border: 1px solid #eee;
              border-bottom: none;
              border-top: none;
              background-color: #fff;
              font-weight: bold;
              color: #046bba;
              font-size: 16px;
            }
          }
        }
      }

      .key-login-extra-links {
        margin-top: 12px;
        padding-bottom: 8px;
        font-size: 14px;
        text-align: center;

        a {
          color: #046bba;
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }
        }

        .key-login-extra-sep {
          margin: 0 8px;
          color: #ccc;
        }
      }
    }

    .loged-box {
      border: 1px solid #eaeaea;
      background-color: #fff;
      padding: 10px;
      line-height: 150%;

      :deep(.el-button) {
        letter-spacing: 1px;
        margin: 10px 0 20px 0;
      }
    }

    .city-zone {
      width: 23.75rem;
      height: 306px;
      border: 1px solid #eaeaea;
      margin-top: 10px;
      background-color: #fff;

      h4 {
        box-sizing: border-box;
        font-weight: bold;
        width: 100%;
        height: 2.5rem;
        line-height: 2.5rem;
        color: #4a8ddf;
        padding-left: 20px;
        border-bottom: 1px solid #eaeaea;
      }
    }

    .tb01 {
      margin: 10px 0 0 16px;

      .title {
        text-align: right;
      }

      td {
        padding: 8px;
      }
    }
  }
}

/* 平板：宽度 ≤ 768px */
@media (max-width: 768px) {
  .province-content {
    .left-box {
      width: 100%;
      margin-bottom: 1rem;
    }

    .right-box {
      width: 100%;

      .city-zone {
        width: 100%;
      }
    }
  }
}
</style>
